import { Avatar, Button, Flex, Popup, Text, TextField } from '@approvalmax/ui/src/components';
import { Form } from '@approvalmax/ui/src/components';
import { zodResolver } from '@hookform/resolvers/zod';
import { selectors } from 'modules/common';
import { memo } from 'react';
import bemFactory from 'react-bem-factory';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { z } from 'zod';

import { saveAndApproveRequest } from '../../actions';
import { isLoading } from '../../selectors/pageSelectors';
import { fieldNames } from './SaveAndApprovePopupContent.constants';
import { messages } from './SaveAndApprovePopupContent.messages';
import { schema } from './SaveAndApprovePopupContent.schema';

const qa = bemFactory.qa('reqf-save-and-approve-popup');

export const SaveAndApprovePopupContent = memo(() => {
    const dispatch = useDispatch();
    const progress = useSelector(isLoading);
    const profile = useSelector(selectors.profile.getProfileUser);

    const form = useForm<z.infer<typeof schema>>({
        resolver: zodResolver(schema),
    });

    const onSubmit = form.handleSubmit((data) => {
        dispatch(saveAndApproveRequest({ skipPreconditions: true, commentText: data[fieldNames.comment] }));
    });

    return (
        <Form form={form} onSubmit={onSubmit}>
            <Popup.Header
                progress={progress}
                qa={qa()}
                title={messages.title}
                actions={
                    <Button data-qa={qa('done-button')} color='blue80' type='submit' progress={progress}>
                        {messages.submitButton}
                    </Button>
                }
            />

            <Popup.Body>
                <Text font='body' spacing='0 0 20'>
                    {messages.description}
                </Text>

                <Text font='body' spacing='0 0 24'>
                    {messages.commentNote}
                </Text>

                <Flex spacing='16' wrap={false}>
                    <Avatar size={40} alt={profile.displayName} src={profile.avatar} />

                    <TextField
                        name={fieldNames.comment}
                        initFocus
                        autoHeight
                        minHeight={60}
                        multiline
                        qa={qa('comment-editor')}
                    />
                </Flex>
            </Popup.Body>
        </Form>
    );
});

SaveAndApprovePopupContent.displayName = 'SaveAndApprovePopupContent';
